import { ArrowRight } from 'lucide-react';

const HowItWorks = () => {
  const steps = [
    {
      number: "1",
      title: "Connect Email",
      description: "Link your recruiting email inbox to automatically import player inquiries.",
      gradient: "from-cyan-500 to-teal-500"
    },
    {
      number: "2", 
      title: "Auto-Processing",
      description: "The system extracts player details and organizes them in your database.",
      gradient: "from-teal-500 to-green-500"
    },
    {
      number: "3",
      title: "Filter & Shortlist", 
      description: "Review player profiles with powerful filtering and create shortlists.",
      gradient: "from-green-500 to-emerald-500"
    },
    {
      number: "4",
      title: "Respond Efficiently",
      description: "Use templates to quickly respond to prospects with personalized emails.",
      gradient: "from-emerald-500 to-cyan-500"
    }
  ];

  return (
    <section id="how-it-works" className="py-24 bg-gradient-to-br from-gray-50 to-cyan-50">
      <div className="container mx-auto px-4">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
            How <span className="bg-gradient-to-r from-cyan-600 to-teal-600 bg-clip-text text-transparent">Bloom</span> Works
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Getting started is easy. Our platform streamlines your recruitment workflow in just a few steps.
          </p>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 relative">
            {steps.map((step, index) => (
              <div key={index} className="relative">
                <div className="text-center group">
                  <div className={`w-16 h-16 bg-gradient-to-r ${step.gradient} rounded-full flex items-center justify-center mx-auto mb-6 text-white text-2xl font-bold shadow-lg group-hover:scale-110 transition-transform duration-300`}>
                    {step.number}
                  </div>
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    {step.title}
                  </h3>
                  <p className="text-gray-600 leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {/* Arrow between steps - positioned to not overlap circles */}
                {index < steps.length - 1 && (
                  <div className="hidden lg:block absolute top-8 -right-4 z-10">
                    <ArrowRight className="w-6 h-6 text-cyan-400" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks; 